// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col } from 'react-flexbox-grid';
import Button from '../common/ButtonComp';
import { getTranslate } from 'react-localize-redux';
import { push } from 'react-router-redux';

import './LoginComp.css';

const accountId = false;
const loginHref = accountId ? `/auth/with-google?accountId=${accountId}` : '/auth/with-google';

class LoginPage extends Component {
  componentWillMount() {
    const {
      me: { unknown, user },
      dispatch
    } = this.props;

    if (!unknown && user) {
      return dispatch(push('/projects'));
    }
  }

  render() {
    const { translate } = this.props;

    return (
      <Row>
        <Col xs={12}>
          <Row center="xs">
            <Col xs={6}>
              <div className="content login-comp">
                <h2>{translate('login.SignInWithGoogle')}</h2>
                <Button href={loginHref} big primary>
                  {translate('login.signIn')}
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  me: state.me,
  translate: getTranslate(state.locale)
});

export default connect(mapStateToProps, null)(LoginPage);



// WEBPACK FOOTER //
// ./src/login/LoginComp.js